function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "calendar-alt",
  d: "M25.5,5A1.5,1.5,0,0,1,27,6.5v19A1.5,1.5,0,0,1,25.5,27H6.5A1.5,1.5,0,0,1,5,25.5V6.5A1.5,1.5,0,0,1,6.5,5ZM7,11H25V7H7ZM21.326,23V14.963H19.65L17.572,16.4v1.564L19.544,16.6h.1V23h1.681Zm-8.283.206c1.833,0,3.158-1.019,3.158-2.428a1.859,1.859,0,0,0-1.793-1.916v-.1a1.812,1.812,0,0,0,1.482-1.838c0-1.264-1.187-2.167-2.835-2.167-1.755,0-2.885.958-2.941,2.479h1.554A1.211,1.211,0,0,1,13.01,16.1c.785,0,1.287.412,1.287,1.058a1.14,1.14,0,0,1-1.281,1.1h-.981v1.254h1c.9,0,1.454.434,1.454,1.136,0,.685-.585,1.158-1.425,1.158-.864,0-1.438-.429-1.488-1.108H9.964c.072,1.515,1.286,2.506,3.079,2.506Z",
  transform: "translate(-5 -5)",
  fill: "#2a67f4"
});

function SvgCalendarAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAlt);
export default ForwardRef;